var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlusIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "3 3 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.424 9.343a.656.656 0 0 0 0 1.31h1.818v1.818a.656.656 0 0 0 1.31 0v-1.818h1.818a.656.656 0 0 0 0-1.31h-1.817V7.525a.656.656 0 0 0-1.31 0L9.24 9.343H7.424Z"
})));
export default SvgPlusIcon;